module.exports = __webpack_public_path__ + "img/compact.b1a16628.png";